import React, {useEffect, useState} from "react";
import Drawer from "@material-ui/core/Drawer";
import ItemMenuList from "./ItemMenuList";
import {makeStyles} from "@material-ui/core/styles";
import clsx from 'clsx';
import {
    AppBar,
    Avatar,
    CssBaseline,
    Divider,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Toolbar,
    Typography
} from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {useHistory} from "react-router-dom";
import StorageService from "../services/StorageService";
import CopyrightIcon from '@material-ui/icons/Copyright';
import BackgroundImage from "../assets/logo.jpeg";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 100,
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        backgroundImage: `url()`,
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    bottomPush: {
        position: "absolute",
        bottom: 0,
        paddingBottom: 10,
        paddingLeft: 15
    },
    avatar: {
        color: theme.palette.secondary.main,
        fontSize: 14,
        borderColor: theme.palette.secondary.main,
        border: '2px solid',
        backgroundColor: "lightgray",
    },
}))

const SideMenu = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const storageService = new StorageService();
    const [open, setOpen] = useState(storageService.getMenuOption());
    const [anchorEl, setAnchorEl] = useState(null);
    const openProfileMenu = Boolean(anchorEl);
    const [providerAccess, setProviderAccess] = useState(false)
    const [name, setName] = useState("");

    const handleDrawerOpen = () => {
        setOpen(true);
        storageService.setMenuOption(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
        storageService.setMenuOption(false)
    }

    const goToProfile = () => {
        history.push('/profile');
    }

    const logout = () => {
        storageService.clearAllStorage();
        history.push('/');
    }

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    useEffect(() => {
        const user = storageService.getObjectLocalStorage('provider');
        const employee = storageService.getObjectLocalStorage('employee');

        if (user === null) {
            return logout();
        }

        if (employee !== null) {
            setName(employee.name)
            return
        }

        setProviderAccess(true)
        setName(user.fancyName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const buildInitials = (name) => {
        const valueSplit = name.split(' ')

        if (valueSplit.length === 1) {
            return name.substr(0, 1)
        }

        if (valueSplit.length === 0) {
            return "DP"
        }

        return `${valueSplit[0][0]}${valueSplit[1][0]}`

    }

    return (
        <div className={classes.root}>
            <CssBaseline/>

            {/* AppBar */}
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        {props.title}
                    </Typography>
                    <Typography>
                        Olá, {name}
                    </Typography>
                    <div>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            {/* <AccountCircle /> */}
                            <Avatar className={classes.avatar}>{buildInitials(name)}</Avatar>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={openProfileMenu}
                            onClose={handleClose}
                        >
                            {providerAccess ? <MenuItem onClick={goToProfile}>Meus Dados</MenuItem> : null}
                            <MenuItem onClick={logout}>Sair</MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>

            {/* Menu */}
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
                style={{backgroundImage: `url(${BackgroundImage})`,}}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon/>
                    </IconButton>
                </div>
                <Divider/>
                <ItemMenuList/>

                <ListItem className={classes.bottomPush}>
                    <ListItemIcon><CopyrightIcon/></ListItemIcon>
                    <ListItemText secondary="Deixa Que Eu Procuro"/>
                </ListItem>
            </Drawer>
        </div>

    );
};

export default SideMenu;
